export const privacyContent = {
  title: "Privacy Policy",
  lastUpdated: "June 2026",
  intro: "At BizNearYou, we protect the privacy of our job seekers and employers. This Privacy Policy details how we handle data.",
  sections: [
    {
      heading: "1. Information Gathered",
      bullets: [
        "Account credentials & email identifiers",
        "Job matcher search parameters & filter choices",
        "Saved local business Businesses & CRM logs",
        "Job preferences (categories, availability, desired pay)",
        "Interaction metrics (impressions, clicks, outreach counts)",
        "Approximate location & zip code lookups used to center mapping queries",
        "Stripe customer billing IDs (we do not store credit cards directly)"
      ]
    },
    {
      heading: "2. Third-Party Integrations",
      text: "Depending on configuration, BizNearYou integrates with Google Maps/Places APIs to retrieve spatial listings, Supabase for safe cloud records, Stripe for payment processing, and secure server-side Gemini AI models for summary analytics. These partners handle data according to their respective privacy guidelines."
    },
    {
      heading: "3. Location Tracking Control",
      text: "Users can toggle all real-time tracking settings in the Settings Menu at any time. When disabled, location search interactions are not persisted in database logs."
    },
    {
      heading: "4. Deletion & Data Rights",
      text: "For any data export, modification, or account deletion request, please submit a support ticket or request an opt-out using the Contact Removal tab."
    }
  ]
};
